import type { AnalyticsSetConfig } from '@cbhq/client-analytics';
import { PlatformName } from '@cbhq/client-analytics';

import { userJourneySteps } from '../utils/userJourneySteps';

import { analyticsConfig as environmentAnalyticsConfig, appVersion } from './environments';

export const analyticsConfig: AnalyticsSetConfig = {
  ...environmentAnalyticsConfig,
  projectName: 'workspace_fe',
  platform: PlatformName.web,
  version: appVersion,
  batchEventsThreshold: 5,
  batchMetricsThreshold: 5,
  isAlwaysAuthed: false,
  steps: userJourneySteps,
};
